// reducers.js

import { SET_SELECTED_BRANCH_ID } from '../../actions/feeManagement/Branchid'

const initialState = {
  selectedBranchId: null
}

const feereducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_BRANCH_ID:
      return {
        ...state,
        selectedBranchId: action.payload
      }
    default:
      return state
  }
}

export default feereducer
